import axios from "axios";
import { getUserLocalStorageToken } from "core/api";
import environment from "../environment/environment";

const api = axios.create();

if (api) {
	api.interceptors.request.use(
		async (config) => {
			try {
				return {
					...config,
					headers: {
						...config.headers,
						Authorization: `Bearer ${sessionStorage.getItem("structured:api-token") || getUserLocalStorageToken()}`,
						"Content-Type": "application/json",
						Accept: "application/pdf",
						"Ocp-Apim-Subscription-Key": `${environment.SUBSCRIPTION_KEY}`,
					},
				};
			} catch (e) {
				return config;
			}
		},
		(error) => Promise.reject(error),
	);
}

export default api;
